import { Pipe, PipeTransform } from "@angular/core";
import { priceBreakdown } from "../ts/priceBreakdown";
import { startCase } from "lodash";

@Pipe({
  name: "PriceName"
})
export class PriceBreakdownPipe implements PipeTransform {
  transform(value: string): string {
    return priceBreakdown[value] || startCase(value);
  }
}
